query CampaignWithLanguagesAndMasterTemplates($campaignId: ID!) {
    campaign(campaignId: $campaignId) {
        _id
        id
        name
        jiraTicketUrl
        wppProjectId
        languages
        campaignType
        masterTemplates {
            _id
            height
            width
        }
        section {
            _id
        }
        wppProjectId
        creativeXPlatformSettings {
            marketCode
            channel
            publisher
            placement
            campaignObjective
            contentType
            adFormat
            assetType
        }
        opendcPlatformSettings {
            campaignType
        }
    }
}
